<template>
    <section class="transfer-places-update-form">
        <el-form
            ref="form"
            v-loading="isLoading"
            :model="form"
            :rules="rules"
        >
            <el-form-item
                label="Название"
                prop="name"
            >
                <el-input
                    v-model="form.name"
                    label="Название"
                />
            </el-form-item>
            <el-form-item label="Информация">
                <el-input
                    v-model="form.description"
                    type="textarea"
                    label="Информация"
                />
            </el-form-item>
        </el-form>
        <div>
            <el-button
                type="success"
                @click="_onUpdateBtnClick"
            >
                Сохранить
            </el-button>
            <el-button
                @click="_onCancelBtnClick"
            >
                Отмена
            </el-button>
        </div>
    </section>
</template>

<script>
import ROUTES from '@/modules/transfer/enums/routes';
import { mapActions } from 'vuex';
import _ from 'lodash';

export default {
    name: 'TransferPlacesUpdateForm',
    data() {
        return {
            isLoading: false,
            initFormData: {
                name: null,
                description: null
            },
            form: {
                name: null,
                description: null
            },
            rules: {
                name: [
                    { required: true, message: 'Укажите название', trigger: 'change' }
                ]
            }
        };
    },
    computed: {
        placeId() {
            return this.$route.params.transferPlaceId;
        }
    },
    mounted() {
        this._getPlaceData();
    },
    methods: {
        ...mapActions('transfer', [
            'getPlace', 'updatePlace'
        ]),
        _goToList() {
            this.$router.push({ name: ROUTES.TRANSFER_PLACES.LIST });
        },
        _getPlaceData() {
            this.isLoading = true;
            this.getPlace(this.placeId).then((response) => {
                this.initFormData.name = response.name;
                this.initFormData.description = response.description;
                this.form = { ...this.initFormData };
            })
                .catch((error) => {
                    let message = _.get(error, 'response.data.message') || error.message;
                    this.$message.error(message);
                    this._goToList();
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        _tryUpdatePlace() {
            let updateData = {};
            Object.keys(this.form).forEach((key) => {
                if (this.form[key] !== this.initFormData[key]) {
                    updateData[key] = this.form[key];
                }
            });
            if (_.isEmpty(updateData)) {
                this._goToList();
                return;
            }
            this.updatePlace({
                placeId: this.placeId,
                data: { ...updateData }
            })
                .then((response) => {
                    if (response.success) {
                        this.$message.success(response.message);
                        this._goToList();
                        return;
                    }
                    throw new Error(response.message);
                })
                .catch((error) => {
                    let message = _.get(error, 'response.data.message') || error.message;
                    this.$message.error(message);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        _onUpdateBtnClick() {
            this.$refs.form.validate()
                .then(() => {
                    this._tryUpdatePlace();
                });
        },
        _onCancelBtnClick() {
            this._goToList();
        }
    }
};
</script>

<style lang="scss">
.transfer-arrival-form {
  max-width: 510px;
}
</style>
